import React, { Component } from 'react'

import styles from './styles.scss'

import WorldItem from './components/world-item'

import { TimelineMax, TweenMax, Power3, Expo } from 'gsap'
import SplitText from 'utils/gsapPlugins/SplitText.min'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import config from 'src/config'
import components from 'src/utils/components'

export default class World extends Component {
  constructor(props) {
    super(props)

    this.key = `worldScreen`
  }

  componentDidMount() {
    this.initTL()
    this.onResize()

    raf.add(this.onRAF)
    resize.add(this.onResize)
  }

  componentDidUpdate() {
    this.onResize()
  }

  componentWillUnMount() {
    raf.remove(this.raf)
    resize.remove(this.onResize)
  }

  initTL() {
    this.tlRAF = new TimelineMax({
      paused: true
    })

    this.tlRAF
      .fromTo(
        this.refs.leftColumn,
        2,
        {
          y: 150
        },
        {
          y: -50
        },
        0
      )
      .fromTo(
        this.refs.rightColumn,
        2,
        {
          y: -100
        },
        {
          y: 50
        },
        0
      )

    this.tlAnimateIn = new TimelineMax({
      paused: true,
      onStart: () => {
        this.tlAnimateInIsPlaying = true
      },
      onComplete: () => {
        this.tlAnimateInIsEnded = true
        this.tlAnimateInIsPlaying = false
      }
    })
      .fromTo(
        this.refs.line,
        1.3,
        {
          x: '-100%'
        },
        {
          x: '0%',
          ease: Expo.easeOut
        },
        0.3
      )
      .fromTo(
        this.refs.firstTitle,
        1.2,
        {
          y: 30,
          opacity: 0
        },
        { y: 0, opacity: 1, ease: Power3.easeOut },
        0
      )
      .fromTo(
        this.refs.secondTitle,
        1.2,
        {
          y: 30,
          opacity: 0
        },
        { y: 0, opacity: 1, ease: Power3.easeOut },
        0.2
      )
      .fromTo(
        this.refs.content,
        1.7,
        {
          y: 30,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          ease: Power3.easeOut
        },
        0.5
      )
  }

  resetTL() {
    this.tlAnimateInIsPlaying = false
    this.tlAnimateInIsEnded = false
    this.tlAnimateIn.pause()
    this.tlAnimateIn.progress(0)
  }

  onResize = () => {
    if (!this.refs.component) return

    const $component = this.refs.component.getBoundingClientRect()
    this.topComponent =
      $component.top + values.scroll.currentY < values.viewport.height + 40
        ? $component.top + values.scroll.currentY
        : $component.top + values.scroll.currentY - values.viewport.height

    this.viewport =
      $component.top + values.scroll.currentY < values.viewport.height
        ? 0
        : values.viewport.height
    this.leftComponent = $component.left

    this.hComponent = this.refs.component.offsetHeight
    this.wComponent = this.refs.component.offsetWidth

    if (values.viewport.width < config.bp.md && !this.tlAnimateIn.progress()) {
      this.tlAnimateIn.progress(100)
      this.tlRAF.paused()

      TweenMax.set([this.refs.leftColumn, this.refs.rightColumn], { y: 0 })
    }

    setTimeout(this.addToMenu, 1)
  }

  addToMenu = () => {
    const obj = {
      order: this.props.order,
      legend: this.props.legend,
      top: this.topComponent
    }

    const module =
      values.viewport.width < config.bp.md ? 'homeMenuMobile' : 'homeMenu'

    components.allComponents[module].addItem(obj)
  }

  onRAF = () => {
    if (!this.refs.component || values.viewport.width < config.bp.md) return

    this.perc =
      (values.scroll.currentY + values.viewport.height - this.topComponent) /
      (values.viewport.height + this.hComponent)

    this.tlRAF && this.perc >= 0 && this.tlRAF.progress(this.perc)

    this.perc >= 0.05 &&
      !this.tlAnimateInIsEnded &&
      !this.tlAnimateInIsPlaying &&
      this.tlAnimateIn.play(0)

    this.perc < 0.15 &&
      components.allComponents.homeMenu.setMenu(this.props.order + 1, true)

    this.perc > 0.15 &&
      this.perc < 0.5 &&
      components.allComponents.homeMenu.setMenu(this.props.order, true)

    this.perc <= -0.1 && this.resetTL()
  }

  render() {
    this.rightColumn = []
    this.leftColumn = []
    const isMobile = values.viewport.width < config.bp.md

    this.props.worlds.types.map((world, i) => {
      if (isMobile) {
        i < this.props.worlds / 2
          ? this.rightColumn.push(world)
          : this.leftColumn.push(world)
      } else {
        i % 2 ? this.rightColumn.push(world) : this.leftColumn.push(world)
      }
    })

    return (
      <div ref="component" className="component world">
        <div className="grid-24">
          <div className="grid-12  m-grid-10 title-container">
            <h2 ref="firstTitle">
              {this.props.title.firstPart}
              <span className="container-line">
                <span ref="line" className="line" />
              </span>
            </h2>
          </div>
          <div className="grid-8 m-grid-10">
            <h2 ref="secondTitle" className="second-title">
              {this.props.title.secondPart}
            </h2>
            <p ref="content" className="content">
              {this.props.content}
            </p>
          </div>
          <div className="grid-16 m-grid-10 worlds-container">
            <div
              ref="leftColumn"
              className="column-10 m-column-12 column-container left-column">
              {this.leftColumn.map((world, i) => {
                return (
                  <WorldItem
                    pos={false}
                    item={i}
                    ref={`worldItemLeft${i}`}
                    key={`worldItemLeft${i}`}
                    {...world}
                    cta={this.props.worlds.cta}
                  />
                )
              })}
            </div>
            <div
              ref="rightColumn"
              className="column-10 m-column-12 column-container right-column">
              {this.rightColumn.map((world, i) => {
                return (
                  <WorldItem
                    pos={true}
                    item={i}
                    ref={`worldItemRight${i}`}
                    key={`worldItemRight${i}`}
                    {...world}
                    cta={this.props.worlds.cta}
                  />
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/world/index.js